import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const DialogHeader = styled('div', {
	shouldForwardProp: (prop) => prop !== 'withImage',
})<{ withImage: boolean }>(({ theme, withImage }) => ({
	display: 'flex',
	alignItems: withImage ? 'flex-start' : 'center',
	justifyContent: 'space-between',
	padding: '10px 8px',

	[theme.breakpoints.down('sm')]: {
		paddingBlock: '0px',
	},
}));
